<template>
	<Hat class="details-header section section--mini screen-start">
		<div class="details-header__body">
			<h2 class="details-header__title">Current balance</h2>
			<p class="details-header__balance" data-currency="USDT">{{ me.balance.toFixed(2) }}</p>
			<p class="details-header__wallet">{{ shorty(me.wallet, 16) }}</p>
		</div>
		<nav class="details-header__footer">
			<Button color="brand" :is="RouterLink" to="/wallet/top-up" class="details-header__button">
				<Icon name="plus" :size="1.3" /> Top up
			</Button>
			<Button color="light" :is="RouterLink" to="/wallet/withdrawal" class="details-header__button">
				<Icon name="up" :size="1.05" /> Withdraw
			</Button>
		</nav>
	</Hat>
	<template v-if="statistic">
		<menu class="details-nav section section--mini">
			<RouterLink class="details-nav__item details-nav-item card card--mini" to="/wallet/deposits" @click="changeOrderBy('deposits')">
				<p class="details-nav-item__title">Deposit</p>
				<div class="details-nav-item__body">
					<p class="details-nav-item__total">Total deposited amount:</p>
					<p class="details-nav-item__value" data-currency="USDT">{{ statistic.deposits.amount.toFixed(2) }}</p>
				</div>
				<div class="details-nav-item__footer">
					<p class="details-nav-item__stat">Number of deposits made:</p>
					<p class="details-nav-item__stat-value" data-unit="Times">{{ statistic.deposits.count }}</p>
				</div>
				<i class="details-nav-item__sort" :class="{
					'details-nav-item__sort--bottom' : orderBy === 'desc' || table !== 'deposits',
					'details-nav-item__sort--top' : orderBy === 'asc' && table === 'deposits'
				}">
					<Icon name="up" />
				</i>
			</RouterLink>
			<RouterLink class="details-nav__item details-nav-item card card--mini" to="/wallet/withdrawals" @click="changeOrderBy('withdrawals')">
				<p class="details-nav-item__title">Withdraw</p>
				<div class="details-nav-item__body">
					<p class="details-nav-item__total">Total withdraw amount:</p>
					<p class="details-nav-item__value" data-currency="USDT">{{ statistic.withdrawals.amount.toFixed(2) }}</p>
				</div>
				<div class="details-nav-item__footer">
					<p class="details-nav-item__stat">Number of deposits made:</p>
					<p class="details-nav-item__stat-value" data-unit="Times">{{ statistic.withdrawals.count }}</p>
				</div>
				<i class="details-nav-item__sort" :class="{
					'details-nav-item__sort--bottom' : orderBy === 'desc' || table !== 'withdrawals',
					'details-nav-item__sort--top' : orderBy === 'asc' && table === 'withdrawals'
				}">
					<Icon name="up" />
				</i>
			</RouterLink>
			<RouterLink class="details-nav__item details-nav-item card card--mini" to="/wallet/referrals" @click="changeOrderBy('referrals')">
				<p class="details-nav-item__title">Referral</p>
				<div class="details-nav-item__body">
					<p class="details-nav-item__total">Bonuses received from:</p>
					<p class="details-nav-item__value" data-currency="USDT">{{ statistic.referrals.amount.toFixed(2) }}</p>
				</div>
				<div class="details-nav-item__footer">
					<p class="details-nav-item__stat">Total number of invited users:</p>
					<p class="details-nav-item__stat-value" data-unit="People">{{ statistic.referrals.count }}</p>
				</div>
				<i class="details-nav-item__sort" :class="{
					'details-nav-item__sort--bottom' : orderBy === 'desc' || table !== 'referrals',
					'details-nav-item__sort--top' : orderBy === 'asc' && table === 'referrals'
				}">
					<Icon name="up" />
				</i>
			</RouterLink>
		</menu>
		<RouterView v-slot="{ Component }">
			<component
				:is="Component"
				:order-by="orderBy"
			/>
		</RouterView>
	</template>
</template>

<script lang="ts" setup>
import "./DetailsView.scss";
import Button from "@/components/Button/Button.vue";
import {RouterLink, useRoute} from "vue-router";
import {onMounted, ref, watch} from "vue";
import Hat from "@/components/Hat/Hat.vue";
import Icon from "@/components/Icon/Icon.vue";
import {useUserStore} from "@/stores/userStore";
import {useApiStore} from "@/stores/apiStore";
import {MeStatisticEntity} from "@/entities/UserEntity";
import {shorty} from "@/modules/helpers";
import {storeToRefs} from "pinia";

let {api} = useApiStore();
let userStore = useUserStore();

let {me} = storeToRefs(userStore);

let route = useRoute();

let table = ref<string>('withdrawals');
let orderBy = ref<'asc' | 'desc'>('desc');
let statistic = ref<MeStatisticEntity | null>(null)

let changeOrderBy = (key : string) => {

	if(table.value === key) {
		orderBy.value = orderBy.value === 'asc' ? 'desc' : 'asc';
	}else{
		table.value = key;
		orderBy.value = 'desc';
	}

}

onMounted(async () => {
	statistic.value = await api.getStatistic();
});

watch(
	() => route.fullPath,
	() => {
		orderBy.value = 'desc';
	}
);

</script>
